import { OptionsIcon } from "assets/icons/OptionsIcon";
import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { ModalConfirm } from "components/ModalConfirm/ModalConfirm";
import { OpcionPedagogicaI } from "interfaces/OpcionPedagogica";
import { Dropdown } from "react-bootstrap";
import { deleteOpcionPedagogica } from "services/opcionPedagogica";

interface Props {
  elemento: OpcionPedagogicaI;
  onClickEdit: (elemento: OpcionPedagogicaI) => void;
  refreshTable: () => void;
}

export const OpcionPedagogicaRowActions = ({
  elemento,
  onClickEdit,
  refreshTable,
}: Props) => {
  const handleDelete = async (id: string | number) => {
    try {
      await deleteOpcionPedagogica(id);
      showSuccessToast("¡La opción pedagógica fue eliminado con éxito!");
      refreshTable();
    } catch (error:any) {
      showErrorToast("Error eliminando la opción pedagógica: ", error.message);
    }
  };

  // const onClickVerDocumento = (id: string | number) => {
  //     openFile({ id })
  // }

  return (
    <Dropdown className="acciones-dropdown | d-flex justify-content-center">
      <Dropdown.Toggle>
        <OptionsIcon />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => onClickEdit(elemento)}>
          Editar
        </Dropdown.Item>

        <ModalConfirm
          title="Eliminar la opción pedagógica"
          onConfirm={() => handleDelete(elemento.id)}
          message={
            <p>
              Estas por eliminar la opción pedagógica {elemento.nombre} <br />
              <b>¿Querés realizar esta acción? Esta acción es irreversible.</b>
            </p>
          }
          renderButton={(handleShow: () => void) => (
            <Dropdown.Item onClick={handleShow}>Eliminar</Dropdown.Item>
          )}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};
